<div class="tw:mb-4">
  <!-- Search Mode -->
  <form [formGroup]="form" class="tw:rounded-lg tw:bg-primary-50 tw:p-4">
    <label>{{ 'PATIENT_SELECTOR.patientName' | translate }}<span class="red">*</span></label>

    <div class="tw:relative tw:mb-4">
      <input
        formControlName="searchValue"
        [typeahead]="searchClients"
        [typeaheadItemTemplate]="itemTemplate"
        [typeaheadMinLength]="3"
        [typeaheadWaitMs]="200"
        (typeaheadNoResults)="noResults = $event"
        [typeaheadLatinize]="true"
        (typeaheadLoading)="typeaheadLoading = $event"
        [typeaheadOptionsLimit]="200"
        [typeaheadOptionsInScrollableView]="8"
        [typeaheadScrollable]="true"
        (typeaheadOnSelect)="typeaheadOnSelect($event)"
        typeaheadOptionField="fullName"
        name="clientsearch"
        type="text"
        class="form-control"
        id="client_name"
        placeholder="{{ 'SHARED.createBookingModal.clientPlaceholder' | translate }}"
        autocomplete="client-name"
        />
    </div>

    <!-- Patient Not Found Message -->
    @if (noResults) {
      <div class="tw:mb-4 tw:flex tw:items-center tw:justify-center tw:rounded-lg tw:bg-neutral-50 tw:p-4">
        <i class="material-icons icon tw:text-neutral-400 tw:mr-2">person</i>
        <span class="tw:text-neutral-600">{{ "PATIENT_SELECTOR.patientNotFound" | translate }}</span>
      </div>
    }
  </form>
</div>

<ng-template #itemTemplate let-model="item" let-index="index">
  <div class="d-flex align-items-center flex-md-row">
    <i class="material-icons opacity-50 mr-2">account_circle</i>
    <div class="item">
      <span class="title d-block">{{ model?.firstName }} {{ model?.lastName }}</span>
      @if (canShowClientContacts() && model?.email && model?.phoneNumber) {
        <span class="desc truncate"> {{ model?.phoneNumber }} • {{ model?.email }} </span>
      }
      @if (canShowClientContacts() && !model?.email && model?.phoneNumber) {
        <span class="desc truncate">{{ model?.phoneNumber }}</span>
      }
      @if (canShowClientContacts() && model?.email && !model?.phoneNumber) {
        <span class="desc truncate">{{ model?.email }}</span>
      }
    </div>
  </div>
</ng-template>
